<template>
  <div class="jm-bg-background-secondary jm-p-3 kpi-block">
    <div class="jm-font-bold" data-test="kpi-value" v-html="kpiValue"></div>
    <div data-test="kpi-label">{{ kpiLabel }}</div>
  </div>
</template>

<script>
export default {
  name: 'KpiBlock',
  props: {
    kpiValue: {
      type: String,
      required: true
    },
    kpiLabel: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.kpi-block {
  border-radius: 10px;
}
</style>
